(function () {
  const KEY = "em_wishlist_v1";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };

  const write = (arr) => {
    localStorage.setItem(KEY, JSON.stringify(arr));
    window.dispatchEvent(new CustomEvent("em:wishlist:changed", { detail: { items: arr } }));
  };

  const norm = (handle) => (handle || "").toString().trim();

  const api = {
    getAll() { return read(); },
    has(handle) { return read().includes(norm(handle)); },
    add(handle) {
      handle = norm(handle);
      if (!handle) return;
      const items = read();
      if (!items.includes(handle)) {
        items.unshift(handle);
        write(items);
      }
    },
    remove(handle) {
      handle = norm(handle);
      const items = read().filter(h => h !== handle);
      write(items);
    },
    toggle(handle) {
      handle = norm(handle);
      const items = read();
      if (items.includes(handle)) {
        write(items.filter(h => h !== handle));
        return false;
      } else {
        items.unshift(handle);
        write(items);
        return true;
      }
    },
    count() { return read().length; },
    clear() { write([]); }
  };

  window.EMWishlist = api;

 window.EMWishlistTrack = function (eventName, props) {
  try {
    if (!window._learnq || typeof window._learnq.push !== "function") return;

    // 1️⃣ IDENTIFY — alleen als klant is ingelogd
    if (window.Shopify && Shopify.customer && Shopify.customer.email) {
      window._learnq.push([
        "identify",
        { $email: Shopify.customer.email }
      ]);
    }

    // 2️⃣ TRACK EVENT
    window._learnq.push([
      "track",
      eventName,
      props || {}
    ]);

  } catch (e) {
    console.error("EMWishlistTrack error", e);
  }
};

})();
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".em-wishlist-heart[data-em-wishlist-handle]");
  if (!btn || !window.EMWishlist) return;

  e.preventDefault();
  e.stopPropagation();

  const handle = btn.getAttribute("data-em-wishlist-handle");
 const becameActive = EMWishlist.toggle(handle);

btn.classList.toggle("is-active", becameActive);

if (becameActive) {
  btn.classList.remove("em-heart-pulse");
  void btn.offsetWidth; // restart animation
  btn.classList.add("em-heart-pulse");

  setTimeout(() => {
    btn.classList.remove("em-heart-pulse");
  }, 450);
}

  // ================================
  // TEST-SCHAKELAAR (alleen als je ?testwishlist=1 gebruikt)
  // ================================
  const isTest = new URLSearchParams(window.location.search).get("testwishlist") === "1";
  const TEST_EMAIL = "timberger@live.nl"; // <-- verander dit als je wilt

  const eventNameAdd = isTest ? "Added to Wishlist TEST" : "Added to Wishlist";
  const eventNameRemove = isTest ? "Removed from Wishlist TEST" : "Removed from Wishlist";

  // Als testmodus: forceer identify op jouw email zodat events NIET op debug@... landen
  if (isTest && window._learnq && typeof window._learnq.push === "function") {
    window._learnq.push(["identify", { $email: TEST_EMAIL }]);
  }

 const rawImg = btn.getAttribute("data-em-wishlist-image") || "";
const rawPrice = btn.getAttribute("data-em-wishlist-price") || "";

// image_url normaliseren
let image_url = rawImg.trim();
if (image_url.startsWith("//")) image_url = "https:" + image_url;
if (image_url && image_url.startsWith("/")) image_url = "https://elanmarais.com" + image_url;

// price normaliseren (39,95 -> 39.95)
let price = rawPrice.toString().trim();
if (price) price = price.replace(",", ".");
const priceNum = price && !isNaN(Number(price)) ? Number(price) : price;

const props = {
  ProductHandle: handle,
  ProductURL: `/products/${handle}`,
  Context: btn.getAttribute("data-em-wishlist-context") || "unknown"
};

if (image_url) props.image_url = image_url;
if (priceNum) props.price = priceNum;


  if (becameActive) window.EMWishlistTrack?.(eventNameAdd, props);
  else window.EMWishlistTrack?.(eventNameRemove, props);
});

function emSyncWishlistHearts() {
  document.querySelectorAll(".em-wishlist-heart[data-em-wishlist-handle]").forEach((btn) => {
    const handle = btn.getAttribute("data-em-wishlist-handle");
    btn.classList.toggle("is-active", window.EMWishlist?.has(handle));
  });
}
window.emSyncWishlistHearts = emSyncWishlistHearts;
window.addEventListener("em:wishlist:changed", emSyncWishlistHearts);
window.addEventListener("pageshow", emSyncWishlistHearts);
document.addEventListener("DOMContentLoaded", emSyncWishlistHearts);
document.addEventListener("shopify:section:load", emSyncWishlistHearts);

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    emSyncWishlistHearts();
  }
});

window.emWishlistSyncHearts = emSyncWishlistHearts;